import React, { ReactNode } from 'react';
import { Header } from './header/Header';
import { Footer } from './Footer';
import { useApp } from '@/hooks/use-app-context';
import { canAccessContributorWorkspace } from '@/lib/auth/roles';
import { MobileBottomNav } from './MobileBottomNav';
import { ProfileCompletionBanner } from './ProfileCompletionBanner';
import { DataPolicyFAB } from './DataPolicyFAB';
import { CookieConsent } from './CookieConsent';
import { ScrollToTop } from '@/components/ui/scroll-to-top';
import { GlobalSearchDialog } from '@/features/search';
import { GlobalCollectorSessionBar } from '@/features/collector/components/GlobalCollectorSessionBar';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  // The footer is for visitors; a signed-in contributor works in an app.
  const { isAuthenticated, user } = useApp();
  // Back-office roles only come here to look at the public site.
  const isContributor = isAuthenticated && canAccessContributorWorkspace(user?.role);
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <GlobalCollectorSessionBar />
      {isContributor ? <ProfileCompletionBanner /> : null}
      <main className={isContributor ? "flex-1 pb-24 md:pb-0" : "flex-1"}>
        {children}
      </main>
      {isContributor ? <MobileBottomNav /> : null}
      <GlobalSearchDialog />
      {isAuthenticated ? (
        <footer className="border-t border-border/60 px-4 py-4 text-center text-xs text-faint-foreground sm:px-6">
          © {new Date().getFullYear()} Umbaji · Yodi Data Hub
        </footer>
      ) : (
        <Footer />
      )}
      {isAuthenticated ? null : <DataPolicyFAB />}
      <CookieConsent />
      <ScrollToTop />
    </div>
  );
}